<template>
  <div class="card" style="padding: 2%">
    <HeaderCard icon="fa fa-file" title="Reporte maestro de operaciones" />
    <div class="card-content">
      <div class="row">
        <form action="" @submit.prevent="buscarInformacion()">
          <div class="col-md-4">
            <label for="Finicial">Fecha inicial:</label>
            <input
              type="date"
              v-model="form.fechaInicial"
              id="Finicial"
              required
              class="form-control"
            />
          </div>
          <div class="col-md-4">
            <label for="Ffinal">Fecha final:</label>
            <input
              type="date"
              v-model="form.fechaFinal"
              id="Ffinal"
              required
              class="form-control"
            />
          </div>
          <div class="col-md-4">
            <label for="" style="color: white">k</label> <br />
            <input
              type="submit"
              value="Buscar datos"
              class="btn btn-fill btn-success"
              style="border-radius: 5px"
            />
          </div>
        </form>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="col-md-12">
            <br />
            <!-- <button class="btn btn-success btn-sm">
                  <i color="black" class="fa fa-download"></i> Exportar
                </button> -->
            <download-excel
              class="btn btn-secondary btn-fill pull-right"
              :data="json_data"
              style="border-radius: 5px"
              :fields="json_fields"
              worksheet="Reporte maestro de avanza"
              :name="`reporte-maestro-de-operaciones-${form.fechaInicial}-${form.fechaFinal}`"
              v-if="json_data != ''"
            >
              Exportar a excel
            </download-excel>
          </div>
        </div>
        <div class="col-md-12">
          <br />
          <TableData :dataRows="data" :colums="tableColumns" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import HeaderCard from "../UIComponents/HeaderCard.vue";
import TableData from "../UIComponents/TableData.vue";
import axios from "axios";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
export default {
  data() {
    return {
      ip: "https://avanti-erp.com/api/",
      form: {
        fechaInicial: "",
        fechaFinal: "",
      },
      data: [],
      tableColumns: [
        {
          prop: "nombreCompletoPaciente",
          label: "Paciente",
          minWidth: 150,
        },
        {
          prop: "entidad",
          label: "Entidad",
          minWidth: 150,
        },
        {
          prop: "fecha",
          label: "Fecha",
          minWidth: 150,
        },
        {
          prop: "horaInicio",
          label: "Hora inicio",
          minWidth: 150,
        },
        {
          prop: "horaFin",
          label: "Hora fin",
          minWidth: 150,
        },
        {
          prop: "sesionesCantidad",
          label: "Cantidad de sesiones",
          minWidth: 150,
        },
        {
          prop: "lugar",
          label: "Lugar",
          minWidth: 150,
        },
        {
          prop: "estadoEventoDescription",
          label: "Estado",
          minWidth: 150,
        },
      ],
      json_fields: {
        "Nombre del paciente": "nombreCompletoPaciente",
        "Tipo de documento": "tipoDocumento",
        "Documento del paciente": "documentoPaciente",
        Entidad: "entidad",
        "Fecha sesión": "fecha",
        'Hora inicio': "horaInicio",
        'Hora final': "horaFin",
        'Cantidad sesiones': "sesionesCantidad",
        Terapeuta: "nombreCompletoTerapeuta",
        Especialidad: "especialidadDescription",
        Ubicación: "lugar",
        Tipo: "estadoEventoDescription",
      },
      json_data: [],
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },
  methods: {
    obtenerEspecialidad: function (){
      return [
        'N/A',
        'N/A',
        'Terapia fisica',
        'Fonoaudiologia',
        'Terapia ocupacional',
        'Educación especial',
        'Psicología'
      ]
    },
    obtenerTipoDocumento: function (){
      return [
        'N/A',
        'NUIP',
        'Cédula de ciudadania',
        'Pasaporte',
        'Tarjeta de identidad',
        'Cedula de extrangeria',
        'Registro civil',
        'NIT',
        'RUT'
      ]
    },
    buscarInformacion: function () {
      const { fechaInicial, fechaFinal } = this.form;
      const dataEspecialidad = this.obtenerEspecialidad();
      const BASE_URL = `${
        this.ip
      }get-master-report/${fechaInicial}/${fechaFinal}/${localStorage.getItem(
        "sede"
      )}`;
      axios
        .get(BASE_URL)
        .then((res) => {
          const result = res.data.data;
          let dataResult = [];
          for (let index = 0; index < result.length; index++) {
            let tipo = "";
            if (result[index]["estadoEvento"] === 2) {
              tipo = "CE";
            } else {
              if (result[index]["tipo"] === "Evaluacion") {
                tipo = "EVA";
              } else if (result[index]["tipo"] === "CYT") {
                tipo = "CYT";
              } else if (result[index]["tipo"] === "GTSL") {
                tipo = "GTSL";
              }else{
                tipo = "SSR";
              }
            }
            dataResult.push({
              nombreCompletoPaciente: `${result[index]["nombrePaciente"]} ${result[index]["apellidoPaciente"]}`,
              nombreCompletoTerapeuta: `${result[index]["nombreTerapeuta"]} ${result[index]["apellidoTerapeuta"]}`,
              estadoEventoDescription: tipo,
              especialidadDescription: dataEspecialidad[result[index]['especialidad']],
              ...(({
                nombrePaciente,
                apellidoPaciente,
                nombreTerapeuta,
                apellidoTerapeuta,
                estadoEvento,
                ...rest
              }) => rest)(result[index]),
            });
          }
          this.data = dataResult;
          this.json_data = dataResult;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  components: {
    HeaderCard,
    TableData,
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Reportes/MaestroV2.vue